import { render, staticRenderFns } from "./DetailScreen.vue?vue&type=template&id=0d1d0362&scoped=true"
import script from "./DetailScreen.vue?vue&type=script&lang=js"
export * from "./DetailScreen.vue?vue&type=script&lang=js"
import style0 from "./DetailScreen.vue?vue&type=style&index=0&id=0d1d0362&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1d0362",
  null
  
)

export default component.exports